import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { AutoCompleteGeneric } from "src/Pages/components/InputAutoCompleted/AutoCompleteGeneric";
import { IPropsAutoCompleted } from "src/Pages/components/InputAutoCompleted/types";

export const AutoCompleteSupervisorReports = (props: IPropsAutoCompleted) => {
  const { disabled, label, width, tamanho, minWidth, maxWidth, fullWidth, placeholder, tooltip, variant } =
    props;

  const { setValueAutoCompSupervisor, valueAutoCompSupervisor } =
    UseAutoCompletedAll();

  return (
    <AutoCompleteGeneric
      disabled={
        disabled
      }
      fullWidth={fullWidth}
      label={label}
      maxWidth={maxWidth}
      minWidth={minWidth}
      setValueAutoCompleted={setValueAutoCompSupervisor}
      tamanho={tamanho}
      url="/getAllProdutores?funcao_produtor=SUPERVISOR"
      valueAutoCompleted={valueAutoCompSupervisor}
      width={width}
      placeholder={placeholder}
      tooltip={tooltip}
      variant={variant}
    />
  );
};
